import PropTypes from 'prop-types';
const FormGroupWrapper = (props) => {
    return (<div className='form__wrapper-group'>
      {props.children}
    </div>);
};
FormGroupWrapper.propTypes = {
    config: PropTypes.object.isRequired,
    children: PropTypes.array.isRequired
};
export default FormGroupWrapper;
